import Vue from 'vue';
import initService from "./init-service";
import sessionIdDirective from "../directive/sessionId-directive";
// import commonService from "./common";
import AdministratorService from "@/common/api-services/administrator-service";
// import coreutils from "@/common/coreutils";

let baseurl = "";
  if(process.env.VUE_APP_CONFIG_ESIM_BASEURL == undefined){
    baseurl = process.env.VUE_APP_CONFIG_BASEURL
  }else {
    baseurl = process.env.VUE_APP_CONFIG_ESIM_BASEURL
  };
let apikey = `${process.env.VUE_APP_CONFIG_APIKEY}`;
let userName = initService.getUserNameInfo();
let customer = initService.getCustomerInfo();
let group = initService.getGroupInfo();
let pId = sessionIdDirective.getJSessionId();
let headers = {
  headers: {
    "Content-Type": "application/json",
    "x-api-key": apikey,
  },
};
const AuthService = {

  //NOTE: This page uses the customer Administrator to allow registration for Admin functions.

  async getLogin(credential) {
    let url = `${baseurl}?method=IOT_Login&credentials=${credential}&auth=1&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
    return Vue.axios.get(url, headers);
  },

  async logoutService() {
    let url = `${baseurl}?method=IOT_Logout&auth=1&user=${userName}&customer=${customer}&group=${group}&pid=${pId}`;
    return Vue.axios.get(url, headers);
  },

  async register(data) {
    let url = `${baseurl}?method=IOT_Register&data=${data}&auth=1&user=${userName}&customer=${customer}&group=${group}&pid=${pId}`;
    return Vue.axios.get(url, headers);
  },

  async forgetPassword(username) {
    let url = `${baseurl}?method=IOT_ForgotPassword&username=${username}&auth=1&user=${userName}&customer=${customer}&group=${group}&pid=${pId}`;
    return Vue.axios.get(url, headers);
  },

  async resetPassword(credentials, code) {
    let url = `${baseurl}?method=IOT_ConfirmForgotPassword&credentials=${credentials}&code=${code}&auth=1&user=${userName}&customer=${customer}&group=${group}&pid=${pId}`;
    return Vue.axios.get(url, headers);
  },

  async updatePassword(data) {
    let url = `${baseurl}?method=IOT_ChangePassword&data=${data}&auth=1&user=${userName}&customer=${customer}&group=${group}&pid=${pId}`;
    return Vue.axios.get(url, headers);
  },

  async respondNewPasswordChallenge(session, credentials) {
    let url = `${baseurl}?method=IOT_RespondNewPasswordChallenge&session=${session}&credentials=${credentials}&auth=1&&customer=${customer}&group=${group}&pid=${pId}`;
    return Vue.axios.get(url, headers);
  },

  async updateUserProfile(username, attr) {
    //NOTE:  this needs to be the user update profile.  The admin method is on the admin service.
    AdministratorService.updateUserProfile(username, attr);
  },

  async getMenuLinks(group="All", noCache=false) {
    let cached = sessionStorage.getItem("menu_links");
    let expiry = sessionStorage.getItem("menu_links_expiry");
    
    if (cached && expiry > Date.now() && !noCache) {
      return JSON.parse(cached);
    } else {
      sessionStorage.removeItem("menu_links");
      sessionStorage.removeItem("menu_links_expiry");
    }

    let url = `${baseurl}?method=User_GetNavigation&group=${group}&customer=${customer}`;
    return Promise.resolve(Vue.axios.get(url, headers))
    .then(response => {
      let new_expiry = Date.now() + 86400000; //24 hours
      sessionStorage.setItem("menu_links_expiry", new_expiry.toString());
      sessionStorage.setItem("menu_links", JSON.stringify(response.data));
      return response.data
    })
    .catch(error => {if (process.env.NODE_ENV === 'dev') console.error(error)});
  },

  async createMenuLink(data) {
    let { attr_type, group, role, name, description, link, icon, icon_color, order } = data;
    let url = `${baseurl}?method=Admin_AddLink&attr_type=${attr_type}&group=${group}&name=${name}&description=${description}&customer=${customer}&roles=${role}&link=${link}&icon=${icon}&icon_color=${icon_color}&order=${order}`;
    return Promise.resolve(Vue.axios.get(url, headers))
    .then(response => response.data)
    .catch(error => console.error(error));
  },

  async updateMenuLink(data) {
    let { id, attr_type, group, role, name, description, link, icon, icon_color, order } = data;
    let url = `${baseurl}?method=Admin_ModifyLink&id=${id}&attr_type=${attr_type}&group=${group}&name=${name}&description=${description}&customer=${customer}&roles=${role}&link=${link}&icon=${icon}&icon_color=${icon_color}&order=${order}`;
    return Promise.resolve(Vue.axios.get(url, headers))
    .then(response => response.data)
    .catch(error => console.error(error));
  },

  async deleteMenuLink(id) {
    let url = `${baseurl}?method=Admin_DeleteLink&id=${id}`;
    return Promise.resolve(Vue.axios.get(url, headers))
    .then(response => response.data)
    .catch(error => console.error(error));
  },

  //TODO: find a better way to store this
  async getActivityLog() {
    //&user=${userName}&group=${group}
    let url = `${baseurl}?method=IOT_GetSubscriberLogs&period=15_min&customer=${customer}&pid=${pId}`;
    return Promise.resolve(Vue.axios.get(url, headers))
        .then(response => response.data.message)
        .catch(error => console.error(error));

    // let param = `IOT_GetSubscriberLogs&period=15_min`;
    // return commonService.commonAPI(param)
    //   .then(response => response.data.message)
    //   .catch(error => console.error(error))
  },

  //TODO: find a better way to store this
  async setActivityLog(action, details, isError = 0) {
    //get the customer, and user
    let userName = initService.getUserNameInfo();
    details = encodeURIComponent(JSON.stringify(details))
    //&group=${group}
    let url = `${baseurl}?method=IOT_AddLog&api=${action}&fault=${isError}&customer=${customer}&user=${userName}&pid=${pId}&response=${details}`;
    return Vue.axios.get(url, headers)
       .then(response => response.data.message)
       .catch(error => console.error(error));


    //let param = `IOT_AddLog&&api=${action}&response=${details}&fault=${isError}&user=${userName}`;
    // return commonService.commonAPI(param)
    //   .then(response => response.data.message)
    //   .catch(error => console.error(error));
  },

  //TODO: find a better way to store this
  async getTransactionHistory(period) {
    //&user=${userName}&group=${group}
    let url = `?method=IOT_GetSubscriberLogs&period=${period}&customer=${customer}&pid=${pId}`;
    //console.log(url);
    return Promise.resolve(Vue.axios.get(url, headers))
        .then(response => response.data.message)
        .catch(error => console.error(error));

    // let param = `IOT_GetSubscriberLogs&period=${period}`;
    // return commonService.commonAPI(param)
    //   .then(response => response.data.message)
    //   .catch(error => console.log(error))
  },

};

export default AuthService;
